<game-info [game]="game!"></game-info>